/** 상품카드 뱃지 컬러 */
var BADGE_COLOR_OPTIONS = [{
  text: 'Soft blue',
  value: '#6391E6'
}, {
  text: 'Strong cyan',
  value: '#009FCE'
}, {
  text: 'Dark gray',
  value: '#2F3438'
}, {
  text: 'Soft red',
  value: '#F05656'
}];

export { BADGE_COLOR_OPTIONS };
//# sourceMappingURL=constants.js.map
